// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2bNiL","buttons":"PendingPaymentAlert_buttons__IE_5s"};